import React, { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { resetRecommendations } from '../../store/redux/slices/recommendationSlice';
import { markFlowAsComplete } from '../../../../sales-conversation/src/services/louiseApiService';
import { resetSelection } from '../../store/redux/slices/selectionSlice';
import { useLouiseDispatch } from '../../../../sales-conversation/src/store/redux/store';
import useSessionId from '../../../../flows/src/hooks/useSessionId';
import useFlowsResetState from '../../../../flows/src/hooks/useFlowsResetState';
import useRiskAnalysisType from '../../hooks/useRiskAnalysisType';
import useCompanyScanResetState from '../../../../company-scan/hooks/useCompanyScanResetState';
import useIsNLplan from '../../../../common/src/hooks/useIsNLPlan';
import useTracking from '../../../../common/src/hooks/tracking/useTracking';
import LoadingSpinner from '../../../../common/src/components/LoadingSpinner';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';

export interface RiskAnalysisRecommendationParams {
  recommendationId: string;
}

const Recommendations: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { trackEvent } = useTracking();
  const { isNL } = useIsNLplan();
  const history = useHistory();
  const { search } = useLocation();
  const dispatch = useLouiseDispatch();
  const { recommendationId } = useParams<RiskAnalysisRecommendationParams>();
  const sessionId = useSessionId();
  const { reset: resetFlows } = useFlowsResetState();
  const { reset: resetCompanyScan } = useCompanyScanResetState();
  const isCompanyScanType = useRiskAnalysisType() === 'company-scan';

  useEffect(() => {
    if (isSocialLoginUrl && !isCompanyScanType) {
      markFlowAsComplete({ conversationId: sessionId, recommendationId });
      dispatch(resetSelection());
      dispatch(resetRecommendations());
      resetFlows();
      history.replace({
        pathname: `/risk-analysis/recommendations/success/${recommendationId}`,
        search,
      });
    } else {
      markFlowAsComplete({ conversationId: sessionId, recommendationId });
      dispatch(resetRecommendations());
      resetFlows();

      if (isCompanyScanType) {
        resetCompanyScan();
        trackEvent('Finalize Company Scan');
        if (isSocialLoginUrl) {
          history.push({
            pathname: `/risk-analysis/recommendations/success/${recommendationId}`,
            search,
          });
        } else {
          history.push({
            pathname: `/risk-analysis/recommendations/company-success/${recommendationId}`,
            search,
          });
        }
      } else {
        dispatch(resetSelection());

        if (isNL) {
          trackEvent('Finalize Risk Analysis NL');
        } else {
          trackEvent('Finalize Risk Analysis BE');
        }
        history.push({
          pathname: `/risk-analysis/recommendations/success/${recommendationId}`,
          search,
        });
      }
    }
  }, []);

  return <LoadingSpinner />;
};

export default Recommendations;
